import Serializable from "@/core/misc/mixins/Serializable";

/**
 * Форма владения водителем транспортным средством:
 * в собственности, арендуется, в безвозмездном пользовании и т.п.
 * Сделано на перспективу экспорта ЗТК во внешнюю систему "Saby TMS"
 */
class VehicleOwnershipType extends Serializable {
  public id: number;
  public name: string;
  /** Идентификатор во внешней системе */
  public externalId: number | null;

  static fromServer(data: any, result = new VehicleOwnershipType()): VehicleOwnershipType {
    super.fromServer(data, result);

    return result;
  }

  toString(): string {
    return this.name;
  }
}

export default VehicleOwnershipType;
